export const VIMEO_BASE_ADDRESS = "https://vimeo.com/";
export const VIMEO_API_BASE_ADDRESS = "https://vimeo.com/api/oembed.json";
export const VIMEO_PLAYER_BASE_ADDRESS = "https://player.vimeo.com/video";
export const defaults = { autopause: true, autoplay: false, title: true };
export const sizes = { default: { width: 720, height: 405 }, wide: { width: 960, height: 540 } };
